import { generateDates } from '../utils/generateDates';
import { transformToMinutesFormat } from '../utils/transformToMinutesFormat';

export const hoursList = generateDates(1, 12, 'increment');
export const minutesList = transformToMinutesFormat(generateDates(0, 59, 'increment'));
export const partOfDay = ['AM', 'PM'];
